import "../../stylesheets/frontofficev2.scss";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "@shared/gallery";
import "@shared/date_picker";
import "@shared/flash_message";

import "../frontoffice/flight";
import "../frontoffice/rentalcar";
import "../frontoffice/iframe";
import "../controllers";

import Rails from "@rails/ujs";

Rails.start();
